import { FC, Suspense } from 'react'

import { Cluster, Icon, Skeleton, Stack, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

import { Preferences } from './preferences/preferences'
import { Settings } from './settings/settings'

export const NotificationSettings: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={
        <Cluster gap={8} y="center">
          <Icon name="Notification" size="md" />
          <Typography variant="h4">{translate('notification-settings.title')}</Typography>
        </Cluster>
      }
      main={
        <Stack gap={16}>
          <Suspense fallback={<Skeleton variant="card" />}>
            <Settings />
            <Preferences />
          </Suspense>
        </Stack>
      }
      footer={<Footer />}
    />
  )
}
